(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eden-collection-filters"] && !Shopify.designMode) return;
  try {
    (function(){
    var HIDE=['package-type','certifications','serum-target-areas'];
    function relabel(){
      var btn=document.querySelector('.collection__filters__toggle');
      if(!btn)return;
      if(!btn.querySelector('.eden-ft__label')){
        var l=document.createElement('span');
        l.className='eden-ft__label';
        l.textContent='Filter & sort';
        btn.appendChild(l);
        var s=document.createElement('span');
        s.className='eden-ft__count';
        btn.appendChild(s);
        btn.classList.add('eden-ft');
      }
      var native=document.querySelector('.collection__products-count');
      var countText=native?native.textContent.trim():'';
      var cs=btn.querySelector('.eden-ft__count');
      if(cs.textContent!==countText)cs.textContent=countText;
      btn.setAttribute('aria-label',countText?'Filter and sort, '+countText:'Filter and sort');
    }
    function prune(){
      document.querySelectorAll('.collection__filter').forEach(function(f){
        var t=f.querySelector('.collection__filter__title');
        if(!t)return;
        var id=(t.getAttribute('aria-controls')||'').replace('CollectionFilter--','');
        var hide=HIDE.indexOf(id)>-1;
        if(!hide&&!f.querySelector('.filter__price')){
          var opts=f.querySelectorAll('.filter__input');
          var live=0;
          opts.forEach(function(i){if(!i.disabled||i.checked)live++});
          if(opts.length&&live<=1&&t.getAttribute('data-filter-active')!=='true')hide=true;
        }
        f.classList.toggle('eden-ft-hidden',hide);
      });
    }
    function sinkSoldOut(){
      document.querySelectorAll('[id$="__main"] .grid').forEach(function(g){
        var cards=[].slice.call(g.children).filter(function(c){return c.classList.contains('product-grid-item')});
        var seenSold=false,needed=false;
        cards.forEach(function(c){
          if(c.classList.contains('soldout'))seenSold=true;
          else if(seenSold)needed=true;
        });
        if(!needed)return;
        cards.forEach(function(c){if(c.classList.contains('soldout'))g.appendChild(c)});
      });
    }
    function rangeButtons(){
      document.querySelectorAll('[id*="section_list_butttons"]').forEach(function(sec){
        if(!sec.getAttribute('data-eden-rb')){
          sec.setAttribute('data-eden-rb','1');
          var labels=[].map.call(sec.querySelectorAll('.list-collections__item__outer'),function(a){
            var leaves=[].filter.call(a.querySelectorAll('*'),function(e){return !e.children.length&&e.textContent.trim()});
            return leaves[leaves.length-1];
          });
          var counts={};
          labels.forEach(function(t){if(t){var w=t.textContent.trim().split(/\s+/)[0].toUpperCase();counts[w]=(counts[w]||0)+1}});
          var top=Object.keys(counts).sort(function(a,b){return counts[b]-counts[a]})[0];
          if(top&&counts[top]>=3&&counts[top]>=labels.length/2){
            labels.forEach(function(t){
              if(!t)return;
              var p=t.textContent.trim().split(/\s+/);
              if(p.length>1&&p[0].toUpperCase()===top)t.textContent=p.slice(1).join(' ');
            });
          }
          var track=sec.querySelector('.carousel--mobile');
          if(track){
            var check=function(){track.classList.toggle('eden-rb-end',track.scrollLeft+track.clientWidth>=track.scrollWidth-4)};
            track.addEventListener('scroll',check,{passive:true});
            window.addEventListener('resize',check);
            check();
          }
        }
      });
    }
    function run(){relabel();prune();sinkSoldOut();rangeButtons()}
    function init(){
      run();
      var busy=false;
      new MutationObserver(function(){
        if(busy)return;
        busy=true;
        requestAnimationFrame(function(){run();busy=false});
      }).observe(document.body,{childList:true,subtree:true});
    }
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  })();
  } catch(e) { console.error(e); }
})();

})();
